$(document).ready(function () {
    // Modals
    $(".modal-trigger").on("click", function () {
        const target = $(this).data("modal");
        openModal('#' + target);
    })

    $(".modal-close, .modal-overlay, .modal-close-btn").on("click", function () {
        closeModal();
    });
});

function openModal(selector) {
    $(selector).attr("aria-hidden", "false");
    $(".modal-overlay").attr("aria-hidden", "false");
}

function closeModal() {
    $(".modal-overlay").attr("aria-hidden", "true");
    $(".modal").attr("aria-hidden", "true");
    closeNavMenu();
}

window.openModal = openModal;
window.closeModal = closeModal;